<template>
  <express-template-detail :is-edit='false'>
  </express-template-detail>
</template>

<script>
import ExpressTemplateDetail from './components/ExpressTemplateDetail'
export default {
  name: 'CreateTemplate',
  components: {
    ExpressTemplateDetail
  }
}
</script>

